import { browser } from '$app/environment';
import type { LayoutLoad } from './$types';
import { QueryClient } from '@tanstack/svelte-query';
import type { SupportedLocale } from '$lib/i18n/initI18n.js';

export const load = (async ({ parent }) => {
    const { language } = await parent();

    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                enabled: browser
            }
        }
    });

    return { queryClient, language };
}) satisfies LayoutLoad<{ queryClient: QueryClient; language: SupportedLocale }>;
